/*  MUI  */
import { Chip, Typography } from '@mui/material';

/*  Shared  */
import { Response } from 'application/Shared/Helpers';
import { Requests } from 'application/Shared/Requests';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  React  */
import React, { Component } from 'react';
import { withRouter } from 'router/withRouter';

/*  Components  */
import ObjectPicker from './Components/ObjectPicker';

class TagPicker extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            objectNameField: 'name',
            objectNameFieldVisualOnly: 'displayVisualOnly',
            objectPayload: []
        };

        /* requests */
        this.requests = new Requests();
    }

    componentDidMount() {
        this.load();
    }

    componentWillUnmount() {
        this.unload();
    }

    load = async () => {
        const { match } = this.props;
        const { clientId } = match.params;

        const params = { size: -1 };
        if (clientId) {
            params.platformTenantId = clientId;
            params.includeClients = true;
        }

        let response;
        try {
            response = await axios.get('/tag', { params });
            if (!Response.hasData(response)) {
                debug.w('No Tags Found', response);
                return;
            }
        } catch (e) {
            return;
        }

        const data = Response.getData(response);
        const tags = data.sort((a, b) => {
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
            return 0;
        });

        const augmentedTags = tags.map((tag) => {
            const { name, color } = tag;

            return {
                ...tag,
                displayVisualOnly: (
                    <Chip
                        label={<Typography>{name}</Typography>}
                        size="small"
                        variant="whiteText"
                        sx={{
                            '& .MuiChip-label': {
                                paddingX: '8px',
                                paddingY: '2px'
                            },
                            backgroundColor: color,
                            marginRight: '4px'
                        }}
                    />
                )
            };
        });

        if (!this.unmounted) {
            this.setState({
                loaded: true,
                objectPayload: augmentedTags
            });
        }
    };

    unload = () => {
        this.unmounted = true;
        this.requests.cancel();
    };

    render() {
        const { props, state } = this;
        const { disableAllOption, unselectedOption, unselectedValue } = props;
        const {
            loaded,
            objectPayload,
            objectNameField,
            objectNameFieldVisualOnly
        } = state;
        if (!loaded) {
            return null;
        }

        return (
            <ObjectPicker
                {...props}
                objectPayload={objectPayload}
                objectNameField={objectNameField}
                objectNameFieldVisualOnly={objectNameFieldVisualOnly}
                disableAllOption={disableAllOption}
                unselectedOption={unselectedOption}
                unselectedValue={unselectedValue}
                disableClearable
            />
        );
    }
}

export default withRouter(TagPicker);
